module.exports = __webpack_public_path__ + "assets/img/firstTime_bg.c6e0926b.png";